/**
 * App Features Tabs
 * Pill tabs that switch between app/panel panels (templates/app-features-tabs-section.php)
 */

var ACTIVE_CLASSES = ['is-active', 'border-[#01092A]', 'bg-[#01092A]', 'font-bold', 'text-white'];
var INACTIVE_CLASSES = ['border-[#E5E9EE]', 'bg-white', 'font-medium', 'text-[#606060]', 'hover:border-[#01092A]', 'hover:text-[#01092A]'];

export function initAppFeaturesTabs() {
    var sections = document.querySelectorAll('.app-features-tabs');

    sections.forEach(function(section) {
        var buttons = Array.prototype.slice.call(section.querySelectorAll('.app-features-tab-btn'));
        var panels = section.querySelectorAll('.app-features-tab-panel');

        if (buttons.length === 0) return;

        function activate(button) {
            var target = button.getAttribute('data-tab');

            buttons.forEach(function(btn) {
                var isActive = btn === button;
                btn.classList.remove.apply(btn.classList, isActive ? INACTIVE_CLASSES : ACTIVE_CLASSES);
                btn.classList.add.apply(btn.classList, isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
                btn.setAttribute('tabindex', isActive ? '0' : '-1');
            });

            panels.forEach(function(panel) {
                panel.classList.toggle('hidden', panel.getAttribute('data-tab-panel') !== target);
            });
        }

        buttons.forEach(function(button, i) {
            button.addEventListener('click', function() {
                activate(button);
            });

            // Arrow key navigation between tabs
            button.addEventListener('keydown', function(e) {
                var next = null;
                if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
                if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
                if (!next) return;
                e.preventDefault();
                next.focus();
                activate(next);
            });
        });
    });
}
